import { z } from "zod";

export const TokenMapSchema = z.record(z.string(), z.string());

export const AiCommentInputSchema = z.object({
    templateId: z.string().default("cms_narrative"),
    editorialPrompt: z.string().nullable().optional(),
    parameterKeys: z.array(z.string()),
    locale: z.string(),
    campaignId: z.number().nullable().optional(),
    ssqVersionId: z.number().nullable().optional(),
    entityType: z.string().nullable().optional(),
    entityId: z.number().nullable().optional(),
});

export const AiCommentOutputSchema = z.object({
    text: z.string(),
    usedParameters: TokenMapSchema,
    model: z.string(),
    generatedAt: z.string(),
    disclaimer: z.string(),
});

export type AiCommentInput = z.infer<typeof AiCommentInputSchema>;
export type AiCommentOutput = z.infer<typeof AiCommentOutputSchema>;
